export const COMPANY_TABLE_VIEW_TYPE = 'companies' as const;
export const ALL_PROJECTS_TABLE_VIEW_TYPE = 'allProjects' as const;
export type ListViewMode =
  | typeof COMPANY_TABLE_VIEW_TYPE
  | typeof ALL_PROJECTS_TABLE_VIEW_TYPE;
